import CustomForm from './CustomForm.vue'

export default {
  install(Vue) {
    Vue.component(CustomForm.name, CustomForm)
  }
}
